import { PlacementTestTileModalComponent } from './modals/placement_test_tile_modal';

angular.module('biz-ng-path-placement', []).component('placementTestTileModal', new PlacementTestTileModalComponent());

require('./core.ts');
export * from './components/placement_test_scores_tile/placement_test_scores_tile';
export * from './components/placement_group/placement_group';
export * from './components/test_score_graph/test_score_graph';



// WEBPACK FOOTER //
// ./app/vendor/biz-ng-path-placement/src/main.ts